export default __webpack_public_path__ + "static/DMSans-Light-112e42cf05509c65d8634890cf2de89e.ttf";